export default {
  path: '/patrol',
  meta: {
    auth: true,
    title: '巡课',
  },
  component: () => import('_views/patrol/patrol-index'),
}
